<!--
    Popup use example :

    modelSearchPop() {
        SDLUtil.show(
            ModelPopup,
            {
                searchModel: this.searchModel,
                rtnFunc: selModelList => {
                    for(let i = 0; i < selModelList.length; i++) {
                        if(_.findIndex(this.modelList, function(m){ return m.CDMODEL == selModelList[i].CDMODEL; }) > -1) {
                            // NOTHING
                        } else {
                            this.modelList.push({
                                CDMODEL: selModelList[i].CDMODEL,
                                NMMODEL: selModelList[i].NMMODEL,
                                CDCOMPANY: selModelList[i].CDCOMPANY,
                                NMCOMPANY: selModelList[i].NMCOMPANY,
                                MAKETNM: selModelList[i].MAKETNM,
                            });
                        }

                        let grid = this.$refs[this.modelGridId].$refs[this.modelGridId];
                        grid.invoke('resetData', this.modelList);
                    }
                }
            },
            { height: 'auto' }
        );
    },
-->
<template>
<div class="modal-mask">
    <div class="modal-wrapper">
        <div class="modal_size lg_size">
            <a class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
            <dl class="modal_content">
                <dt class="ellipsis">
                    <i>{{ $t('TITLE.POPUP.SEARCH.MODEL') }}</i>
                </dt>
                <dd>
                    <div class="srchModal_wrap select_set2">
                        <dl class="dl_search">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" v-model="searchKey">
                                    <option value="modelCode">{{ $t('FIELD.GLOBAL.MODEL.CODE') }}</option>
                                    <option value="modelName">{{ $t('FIELD.GLOBAL.MODEL.NAME') }}</option>
                                    <option value="marketingName">{{ $t('FIELD.GLOBAL.MARKETINGNAME') }}</option>
                                </select>
                            </dd>
                            <dd class="clearable" data-input-type="input">
                                <input
                                    type="text"
                                    class="text_input w100p"
                                    v-model.trim="searchName"
                                    placeholder="Enter search keyword , model code , marketing name"
                                    @keyup.enter.stop="onSearch()"
                                    v-clearable
                                />
                            </dd>
                            <dd class="btn"><a class="btn_srch" @click="onSearch()">{{ $t('BUTTON.GLOBAL.SEARCH') }}</a></dd>
                        </dl>
                    </div>
                    <dl class="srcModel_wrap">
                        <dt class="scroll" data-type="table">
                            <div class="grid_wrap">
                                <toast-grid
                                    :gridId="gridId"
                                    :columns="columns"
                                    :data="gridData"
                                    :options="options"
                                    :ref="gridId"
                                    :key="gridKey"
                                    :pageOptions="pageOptions"
                                    :isTotalCount="true"
                                />
                            </div>
                        </dt>
                        <dd class="btn">
                            <span>
                                <a href="javascript:" class="ico_arrow_next box" @click="addModel"></a>
                                <a href="javascript:" class="ico_arrow_prev box" @click="removeModel"></a>
                            </span>
                        </dd>
                        <dd class="scroll" data-type="list">
                            <ul id="selModelList" v-for="(selModel, idx) in selModelList">
                                <!-- Selected Model List -->
                                <li data-id="idx"
                                    data-model-code="selModel.CDMODEL"
                                    data-model-name="selModel.NMMODEL"
                                    data-company-code="selModel.CDCOMPANY"
                                    data-company-name="selModel.NMCOMPANY"
                                    data-category1="selModel.PRD_CATEGORY_CD1"
                                    data-category2="selModel.PRD_CATEGORY_CD2"
                                    data-category3="selModel.PRD_CATEGORY_CD3"
                                    data-cdgbm="selModel.CDGBM"
                                    :class="selModelCode == selModel.CDMODEL ? 'active' : ''"
                                    @click="selModelCodeInList(selModel.CDMODEL)"
                                >{{ selModel.CDMODEL }}</li>
                            </ul>
                        </dd>
                    </dl>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) S -->
                <dd class="scroll_btm">
                    <div class="btn_modal_wrap topLine set_2">
                        <a href="javascript:" :title="$t('BUTTON.GLOBAL.EXCELDOWNLOAD')" class="btn_white" @click="btnExcelDownload" >{{ $t('BUTTON.GLOBAL.EXCELDOWNLOAD') }}</a>
                        <div class="btn_right text-right">
                            <a href="javascript:" class="btn_white" @click="$emit('close')">{{ $t('BUTTON.GLOBAL.CANCEL') }}</a>
                            <a href="javascript:" class="btn_blue" @click="onApply()">{{ $t('BUTTON.GLOBAL.APPLY') }}</a>
                        </div>
                    </div>
                </dd>
                <!-- 200707수정(버튼 하단으로 이동) E -->
            </dl>
        </div>
    </div>
</div>
</template>
<script>
import Vue          from 'vue';
import axios        from 'axios';
import qs           from 'query-string';
import $            from 'jquery';
import store        from '@/vuex/store';
import SDLUtil      from '@/utils/SDLUtil';
import ToastGrid    from '~c/ToastGrid';
import ExcelDownloadPopup   from '~vb/common/ExcelDownloadPopup';

export default {
    name: 'KnowledgeModelPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    props: {
        searchModel: { default: '' },
        targetType: { default: 'S' },
        corpNoList: { default: [] },
        categoryCd2: { default: '' },
        categoryCd3: { default: '' },
        rtnFunc: {
            type: Function,
        }
    },
    data() {
        return {
            pageName: 'KnowledgeModelPopup',
            searchKey: 'modelCode',
            searchName: this.searchModel,
            gridKey: 0,
            gridId: 'knowledgeModelPopupGrid',
            columns: [
                //{ header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBSIDIARY'), name: 'NMCOMPANY', align: 'center', width: 100, resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'), name: 'CDMODEL', align: 'center', width: 100, resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.NAME'), name: 'NMMODEL', align: 'center', width: 100, resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PRODUCT.TYPE'), name: 'NMPRODTYPE', align: 'center', width: 90, resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.PRODUCT.SUBTYPE'), name: 'NMPRODSUBTYPE', align: 'center', width: 130, resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.MARKETINGNAME'), name: 'MAKETNM', align: 'center', width: 150, resizable: true, sortable: false },
                { header: 'CDCOMPANY', name: 'CDCOMPANY', hidden: true },
                { header: 'CDGBM', name: 'CDGBM', hidden: true },
            ],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: true,
                minBodyHeight: 80,
                bodyHeight: 265,
                rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 100,
            },
            selModelCode: '',
            selModelList: []
        };
    },
    methods: {
        async onSearch() {
            if (SDLUtil.textLength(this.searchName) < 3) {
                SDLUtil.alert(SDLUtil.getMsgProp('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH'));
                return false;
            }
            SDLUtil.showLoadingBar(true);
            return await axios.post(
                    `${SDLUtil.API_URL}/basis/knowledge/findModelBySubsidiary.skp`,
                    qs.stringify({
                        searchKey: this.searchKey,
                        searchName: this.searchName,
                        targetType: this.targetType,
                        cdProdType: this.categoryCd2,
                        cdProdSubType: this.categoryCd3,
                        corpNoStr: this.corpNoList.join(':')
                    }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(resp => {
                    if(this.selModelList.length === 0) { this.selModelCode = '' };
                    this.gridData = resp.data.result.rowData;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        selModelCodeInList(modelCd) {
            if(this.selModelCode !== modelCd) {
                this.selModelCode = modelCd;
            }
        },
//         copyAllModel() {
//             const searchData = this.gridData;
//             console.log("searchData ==> ",searchData);
//             this.selModelList = [];
//             for(let i = 0; i < searchData.length; i++) {
//                     this.selModelList.push({
//                         CDMODEL : searchData[i].CDMODEL,
//                         NMMODEL : searchData[i].NMMODEL,
//                         CDCOMPANY : searchData[i].CDCOMPANY,
//                         NMCOMPANY : searchData[i].NMCOMPANY,
//                         MAKETNM : searchData[i].MAKETNM,
//                         CDGBM: searchData[i].CDGBM
//                     });
//                 }
//         },
        // ExcelDownloadAll model  (knowledgeModePopup page)
        btnExcelDownload() {
            SDLUtil.showLoadingBar(true);
            //const formData = this.setSearchParameter();
            return axios.post(
                    `${SDLUtil.API_URL}/basis/knowledge/findModelBySubsidiaryExcel.skp`,
                    qs.stringify({
                        searchKey: this.searchKey,
                        searchName: this.searchName,
                        targetType: this.targetType,
                        cdProdType: this.categoryCd2,
                        cdProdSubType: this.categoryCd3,
                        corpNoStr: this.corpNoList.join(':')
                    }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                )
                .then(resp => {
                    let that = this;
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.EXCEL_FILES.length > 0) {
                        SDLUtil.show(
                            ExcelDownloadPopup,
                            {
                                title: 'Excel Download - ' + SDLUtil.getMsgProp('TITLE.POPUP.SEARCH.MODEL'),
                                excelFiles: resp.data.excelFiles,
                            }, // component params
                            {
                                height: 'auto',
                            }, // dialog params
                        );
                    }
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        addModel() {
            const checkedRow = this.$refs[this.gridId].$refs[this.gridId].invoke('getCheckedRows');
            for(let i = 0; i < checkedRow.length; i++) {
                if(_.findIndex(this.selModelList, function(m){ return m.CDMODEL == checkedRow[i].CDMODEL; }) > -1){
                    // NOTHING
                } else {
                    this.selModelList.push({
                        CDMODEL : checkedRow[i].CDMODEL,
                        NMMODEL : checkedRow[i].NMMODEL,
                        CDCOMPANY : checkedRow[i].CDCOMPANY,
                        NMCOMPANY : checkedRow[i].NMCOMPANY,
                        MAKETNM : checkedRow[i].MAKETNM,
                        CDGBM: checkedRow[i].CDGBM
                    });
                }
            }
        },
        removeModel() {
            let self = this;
            let findIdx = _.findIndex(this.selModelList, function(m){ return m.CDMODEL == self.selModelCode; });
            delete this.selModelList.splice(findIdx, 1);
            this.selModelCode = '';
        },
        onApply() {
            this.rtnFunc(this.selModelList);
            this.$emit('close');
        }
    },
    mounted() {
        this.$nextTick(() =>{
            if(!SDLUtil.isNull(this.searchModel)) this.onSearch();
        });
    }
};
</script>

<style>
.text-right { text-align: right; }
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/popup/KnowledgeModelPopup.vue